import { Box, Checkbox, Typography } from "@mui/material";
import React from "react";
import { useTreeModifyContext } from "./TreeDataContext";
import { usePathContext } from "./PathInfo";

interface BooleanProps {
  propName: string;
  value: boolean;
}

export function BooleanComponent(props: BooleanProps) {
  const { saveChangesAtPath } = useTreeModifyContext();
  const { path } = usePathContext();

  function performSave(newValue: any) {
    saveChangesAtPath(newValue, path);
  }

  return (
    <Box className="horizontal-flex">
      <Typography component={"span"}>{props.propName}: </Typography>
      <Checkbox
        checked={props.value}
        onChange={(event) => {
          performSave(event.target.checked);
        }}
      />
    </Box>
  );
}
